const isOpen = state => state.AssessmentStore.invitationAssessmentDialog.opened

const getAssessmentFileId = state =>
  state.AssessmentStore.invitationAssessmentDialog.id

export { isOpen, getAssessmentFileId }
